export default {
  aide_permis: [
    "aide_financement_permis_apprenti",
    "aide_permis_demandeur_emploi",
    "aide_permis_pro_btp",
    "cambrai_aide_mobilite_permis_b",
    "haut_de_france_aide_permis",
    "iwuy_aide_mobilite_permis",
    "le_cateau_aide_mobilite_permis",
    "les_rues_des_vignes_aide_mobilite_permis",
    "loire_atlantique_aide_mobilite_permis_am",
    "loire_atlantique_aide_mobilite_permis_b",
    "msa_armorique_aide_permis",
    "msa_haute_normandie_aide_permis",
    "msa_midi_pyrenees_sud_aide_permis",
    "msa_nord_pas_de_calais_aide_permis",
    "msa_portes_de_bretagne_aide_permis",
    "pret_formation_permis_eligibilite",
  ],
}
